import React from 'react';
import styled from 'styled-components';
import Title from './Title';
import ExpUsetech from '../Experience/ExpUsetech';
import ExpSigma from '../Experience/ExpSigma';
import ExpSkolkovo from '../Experience/ExpSkolkovo';
import ExpAMT from '../Experience/ExpAMT';

const Container = styled.section`
    grid-row: 3;
    grid-column: 1;
`;
const ContainerFlex = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
`;

const Experience = () => {
    return (
        <Container id='exp'>
            {Title('03', 'EXP')}
            <ContainerFlex>
                <ExpAMT />
                <ExpSkolkovo />
                <ExpUsetech />
                <ExpSigma />
            </ContainerFlex>
        </Container>
    );
};

export default Experience;
